import { Action } from '@ngrx/store';
import {
  GeneralApiResponseInterface,
  TableQueryParams,
} from '../../layout/main/main.model';
import {
  CustomUserManagementFilterOutputInterface,
  UserInterface,
} from './user-management.model';

export enum UserManagementActionTypes {
  GetUsers = '[User] Get Users',
  GetUsersCompleted = '[User] Get Users Completed',
  GetUser = '[Device] Get User',
  GetUserCompleted = '[Device] Get User Completed',
  CreateUser = '[User] Create User',
  CreateUserCompleted = '[User] Create User Completed',
  UpdateUser = '[User] Update User',
  UpdateUserCompleted = '[User] Update User Completed',
  DeleteUser = '[User] Delete User',
  DeleteUserCompleted = '[User] Delete User Completed',
  UploadUser = '[User] Upload User',
  UploadUserCompleted = '[User] Upload User Completed',
  ClearState = '[User] Clear State',
  FetchError = '[User] Fetch Error',
}

export class GetUsers implements Action {
  readonly type = UserManagementActionTypes.GetUsers;

  constructor(
    public filters: CustomUserManagementFilterOutputInterface,
    public query: TableQueryParams = {
      page: 1,
      pageSize: 10,
    },
    public timezone: string,
  ) {}
}

export class GetUsersCompleted implements Action {
  readonly type = UserManagementActionTypes.GetUsersCompleted;

  constructor(public usersList: UserInterface[], public itemTotal: number) {}
}

export class GetUser implements Action {
  readonly type = UserManagementActionTypes.GetUser;

  constructor(public deviceId: number) {}
}

export class GetUserCompleted implements Action {
  readonly type = UserManagementActionTypes.GetUserCompleted;

  constructor(public user: GeneralApiResponseInterface<UserInterface>) {}
}

export class CreateUser implements Action {
  readonly type = UserManagementActionTypes.CreateUser;

  constructor(public payload: UserInterface) {}
}

export class CreateUserCompleted implements Action {
  readonly type = UserManagementActionTypes.CreateUserCompleted;

  constructor(public response: GeneralApiResponseInterface<UserInterface[]>) {}
}

export class UpdateUser implements Action {
  readonly type = UserManagementActionTypes.UpdateUser;

  constructor(public payload: UserInterface, public id: number) {}
}

export class UpdateUserCompleted implements Action {
  readonly type = UserManagementActionTypes.UpdateUserCompleted;

  constructor(public response: GeneralApiResponseInterface<UserInterface>) {}
}

export class DeleteUser implements Action {
  readonly type = UserManagementActionTypes.DeleteUser;
  constructor(public payload: number[]) {}
}

export class DeleteUserCompleted implements Action {
  readonly type = UserManagementActionTypes.DeleteUserCompleted;
  constructor(public deletedUsers: any[]) {}
}

export class UploadUser implements Action {
  readonly type = UserManagementActionTypes.UploadUser;
  constructor(public file: any, public userId: number) {}
}

export class UploadUserCompleted implements Action {
  readonly type = UserManagementActionTypes.UploadUserCompleted;
  constructor(public result: any) {}
}


export class ClearState implements Action {
  readonly type = UserManagementActionTypes.ClearState;
}

export class FetchError implements Action {
  readonly type = UserManagementActionTypes.FetchError;

  constructor(public payload: any[]) {}
}

export type UserManagementActions =
  | GetUsers
  | GetUsersCompleted
  | GetUser
  | GetUserCompleted
  | CreateUser
  | CreateUserCompleted
  | UpdateUser
  | UpdateUserCompleted
  | DeleteUser
  | DeleteUserCompleted
  | UploadUser
  | UploadUserCompleted
  | ClearState
  | FetchError;
